import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { Pagination } from "@cinch-nx/shared-ui";
import { useRouter } from "next/router";
export var ReviewHubPagination = function(param) {
    var currentPage = param.currentPage, _resultsPerPage = param.resultsPerPage, resultsPerPage = _resultsPerPage === void 0 ? 10 : _resultsPerPage, total = param.total, _isISR = param.isISR, isISR = _isISR === void 0 ? false : _isISR;
    var ref = useRouter(), isFallback = ref.isFallback, query = ref.query, asPath = ref.asPath;
    var dict = {};
    if (isISR) {
        /*
     ** Please note this is very hacky and should be refactored
     ** In this case 'make' is actually the first part of the path immendiately after '/reviews/'
     ** And 'model' is actually the second part of the path immendiately after '/make/'
     ** The values of make could be actual car makes or 'page'
     ** likewise the values of model could be actual car models or 'page'
     */ var ref1 = _sliced_to_array(asPath.split("/").slice(2), 2), make = ref1[0], model = ref1[1];
        if (make && make !== "page") {
            dict.make = make;
        }
        if (model) {
            dict.model = model;
        }
    } else {
        if (typeof query.make === "string") {
            dict.make = query.make;
            if (typeof query.model === "string") {
                dict.model = query.model;
            }
        }
    }
    var queryString = new URLSearchParams(dict).toString();
    if (isFallback) {
        return null;
    }
    var sourcePage = isISR && dict.make ? "reviews/".concat(dict.make) : "reviews";
    return /*#__PURE__*/ _jsx(Pagination, {
        totalItemsCount: total,
        activePage: currentPage,
        itemsCountPerPage: resultsPerPage,
        sourcePage: sourcePage,
        enabledLinks: true,
        includedQueryParams: queryString.length > 0 && isISR === false ? "?".concat(queryString.toString()) : ""
    });
};
